import { Grid2 as Grid, Typography } from '@mui/material'
import SmallCard from 'App/components/CollectionPageCards/SmallCard/SmallCard'

export interface EditorialArticleListItemProps {
  properties: {
    articleCategory: string
    pageType: string
    image: string
    heading: string
    preamble: string
    startPublish: string
    url: string
  }
}

export interface EditorialRelatedContentBlockProps {
  content: {
    heading: string
    articleListItems: EditorialArticleListItemProps[]
    fallbackImage?: string
  }
}

const EditorialRelatedContentBlock = ({
  content: { heading, articleListItems, fallbackImage },
}: EditorialRelatedContentBlockProps) => {
  return (
    <>
      {articleListItems?.length > 0 && (
        <section data-testid="editorial-article-list-block">
          <Typography variant="subtitle1" color="text.secondary" mb={2}>
            {heading}
          </Typography>

          <Grid container spacing={3} maxWidth={'752px'}>
            {articleListItems.map((item, index) => (
              <Grid
                size={12}
                key={`editorial-related-card-${index.toString()}`}
              >
                <SmallCard
                  cardContent={{
                    properties: {
                      heading: item.properties.heading,
                      preamble: item.properties.preamble,
                      category: item.properties.articleCategory,
                      image: item.properties.image,
                      link: { text: '', url: item.properties.url },
                      knowledgeLevel: '',
                      pageType: item.properties.pageType,
                      timeSpan: { value: 0 },
                      isRelatedContent: true,
                    },
                  }}
                  mediaUrl={window.APP_CONFIGURATION.COMMON.MEDIA_URL}
                  fallbackImage={fallbackImage}
                />
              </Grid>
            ))}
          </Grid>
        </section>
      )}
    </>
  )
}

export default EditorialRelatedContentBlock
